import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Modal, Flex } from '@mprolab/uikit'
import { ProviderActionModalProps } from './index.types'
import ProviderActionModalContent from './ProviderActionModalContent'

const StyledModalWrapper = styled(Flex)`
  flex-direction: column;
  ${({ theme }) => theme.mediaQueries.sm} {
    width: 100%;
  }
  ${({ theme }) => theme.mediaQueries.md} {
    width: 493px;
  }
`

const ProviderActionModal: React.FC<ProviderActionModalProps> = (props) => {
  const { t } = useTranslation()
  const { onDismiss = () => null, manual } = props

  const closeModalHandler = () => {
    onDismiss()
  }

  return (
    <Modal
      onDismiss={closeModalHandler}
      title={manual ? t('walletConnect.manualNetworkChoice') : t('walletConnect.networkSwitching')}
    >
      <StyledModalWrapper mt="24px">
        <ProviderActionModalContent {...props} />
      </StyledModalWrapper>
    </Modal>
  )
}

export default ProviderActionModal
